import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import NewsCard from './NewsCard';

function NewsSection() {
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
      const fetchNews = async () => {
          try {
              const res = await axios.get(
                  `${process.env.REACT_APP_BACKEND_API_URL}/api/news?sort[0]=order:asc&sort[1]=Date:desc&pagination[limit]=3&populate=*`
              );
  
              const mappedNews = res.data.data.map((item) => {
                  const attrs = item.attributes || item;
  
                  const unique = attrs.unique ?? item.unique;
                  return {
                      id: item.id,
                      title: attrs.Title,
                      content: attrs.Content,
                      date: attrs.Date,
                      order: attrs.Order,
                      category: attrs.CategoryName || 'News',
                      link: unique ? `/news/${unique}` : `/news/${item.id}`,
                  };
              });
  
              setNewsItems(mappedNews);
          } catch (error) {
              console.error('Error fetching news:', error);
          }
      };
  
      fetchNews();
  }, []);

  return (
    <section className="news-section py-5" id="news">
      <Container>
        <div className="news-section__header">
          <h3 className="news-section__title mb-5">Latest News</h3>
        </div>
        <Row className="g-4">
          {newsItems.length === 0 && <p className="news-section__loading">Loading latest news...</p>}

          {newsItems.map((news, idx) => (
            <Col key={idx} md={4}>
              <NewsCard news={news} />
            </Col>
          ))}
        </Row>
        
        {newsItems.length > 0 && (
          <div className="news-section__cta-row">
            <Link to="/news" className="news-section__cta">
              View All News Releases <span className="news-section__cta-arrow">➔</span>
            </Link>
          </div>
        )}
      </Container>
    </section>
  );
}

export default NewsSection;
